import type { MapRuntimePort } from './map-runtime';
import type { WindPluginFactories } from './weather-layer-controller';

declare global {
  interface Window {
    MaplibreWindGL?: any;
    MaplibreWind?: any;
  }
}

function loadScriptOnce(id: string, src: string) {
  if (document.getElementById(id)) return Promise.resolve();
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });
}

export async function prepareWindPlugins(
  installPluginRuntime: () => void,
  assetUrl: (path: string) => string
): Promise<WindPluginFactories> {
  installPluginRuntime();
  await loadScriptOnce('maplibre-wind-js', assetUrl('lib/maplibre-wind.js'));
  await loadScriptOnce('maplibre-wind-gl-js', assetUrl('lib/maplibre-wind-gl.js'));
  if (!window.MaplibreWindGL || !window.MaplibreWind) throw new Error('Wind plugin unavailable');
  return {
    createLayer: ({ id, ...options }) => new window.MaplibreWindGL(id, options),
    createCanvas: (runtime: MapRuntimePort, options) => new window.MaplibreWind(runtime, options)
  };
}
